export default "/images/vendor/flag-icons/flags/1x1/pr.svg?792ff9ec3c2a2a501f38de9e26e43ce4";